import {types} from 'mobx-state-tree';

const LanguageModel = types.model('LanguageModel', {
  id: types.identifierNumber,
  code: types.string,
  name: types.string
});

export type LanguageModel = typeof LanguageModel.Type;

export default LanguageModel;



// WEBPACK FOOTER //
// ./src/models/LanguageModel/LanguageModel.ts